/**
 * @module element-injector
 * Injects an element from the DOM into a target element.
 * Useful for injecting elements like tags or badges into other components.
 * @example
 * <div v-element-injector="{ target: 'accordion-item-label', injected: 'chip-tag' }">
 *   <div class="chip-tag">Exclusive</div>
 * </div>
 */

function findParentWithClass(element, className) {
  let accordionItem = element.parentElement

  while (accordionItem) {
    if (accordionItem.classList.contains('accordion-item')) {
      break
    }
    accordionItem = accordionItem.parentElement
  }

  if (!accordionItem) {
    return null
  }

  return accordionItem.querySelector(`.${className}`)
}

function injectContent(el, options) {
  const { target, injected } = options

  if (!target || !injected) {
    console.warn('element-injector: Both target and injected properties are required.')
    return
  }

  const accordionParent = findParentWithClass(el, target)

  if (!accordionParent) {
    console.warn('element-injector: target element not found. Will not inject content.')
    return
  }

  const chipTagContent = el.querySelector(`.${injected}`)

  if (!chipTagContent) {
    console.warn(`element-injector: Does not contain a ${injected} element. Will not inject content.`)
    return
  }

  const existingChipTag = accordionParent.querySelector(`.${injected}`)

  if (existingChipTag) {
    console.info('element-injector: Element already exists. Will not inject duplicate.')
    return
  }

  const contentToInject = chipTagContent.cloneNode(true)
  accordionParent.appendChild(contentToInject)
}

export const elementInjector = {
  name: 'element-injector',

  inserted(el, binding) {
    injectContent(el, binding.value)
  },

  update(el, binding) {
    injectContent(el, binding.value)
  },
}
